<template>
  <ipo3-page>
    <template slot="title">網頁設置</template>
    <template slot="tools">
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.create_at|formDate}}
               </template>
            </el-table-column>
            
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >編輯</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "webpages",
  data() {
    return {
      activeName: "1",
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: this.$table.webpage_menus,
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var self = this;
      this.$http.get("/admin/webpage", {language:this.language}).then(res => {
        console.log("res:", res);
        let { data } = res.data;
        self.tableData = res.data.data;
      });
    },
    onCreate() {
      this.$router.push({ path: "/dashboard/webpage-edit", query: {language:this.language}});
    },
    onHandle(index, id) {
      this.$router.push({ path: `/dashboard/webpage-edit/${id}` });
    },
     onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/webpage/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getData();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
    onChangeLanguage(value) {
      this.getData();
    },
  }
};
</script>